export default "__VITE_ASSET__CjOkqzfY__"